import { createSlice } from "@reduxjs/toolkit";
import { getActiveRoles } from "./roleService";

const initialState = {
    activeRoles: {
        status: null,
        roles: null,
    }
};

const roleSlice = createSlice({
    name: "role",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getActiveRoles.pending, (state) => {
            state.activeRoles.status = 'loading';
            state.activeRoles.roles = null;
        });
        builder.addCase(getActiveRoles.fulfilled, (state, action) => {
            state.activeRoles.status = 'success';
            state.activeRoles.roles = action.payload;
        });
        builder.addCase(getActiveRoles.rejected, (state, action) => {
            state.activeRoles.status = 'failed';
            state.activeRoles.roles = null || 'Failed to get the roles';
        });
    }
});

export const selectActiveRoles = (state) => state.role.activeRoles;
export default roleSlice.reducer;
